import axios from "axios";
import authHeader from "./auth-header";
import ICashBox from "../types/cash-box.type";
import ICashBoxChangeStatus from "../types/cash-box-change-status.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/cash-box`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (cashBox: ICashBox) => {
  return axios.post(API_URL, cashBox, { headers: authHeader() });
};

export const update = (id: number, cashBox: ICashBox) => {
  return axios.put(API_URL + "/" + id, cashBox, { headers: authHeader() });
};

export const changeStatus = (id: number, status: ICashBoxChangeStatus) => {
  return axios.put(API_URL + "/" + id + "/change-status", status, { headers: authHeader() });
};

export const getCashBoxes = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getMyCashBoxes = (params: {}) => {
  return axios.get(API_URL + "/my-cash-boxes", { params: params, headers: authHeader() });
};

export const deleteById = (id: any) => {
  return axios.delete(API_URL + "/" + id, { headers: authHeader() });
};
